export default "__VITE_ASSET__DorjZ6vv__"